import { IMessageContentExtra } from '@/types'
import { atom, useAtom } from 'jotai'

export const globalLoadingAtom = atom(false)
globalLoadingAtom.debugLabel = 'globalLoadingAtom'

export const useGlobalLoading = () => {
  const [globalLoading, setGlobalLoading] = useAtom(globalLoadingAtom)

  return {
    globalLoading,
    setGlobalLoading,
  }
}

export const taskCompleteAtom = atom<Record<string, string> | IMessageContentExtra>({})
taskCompleteAtom.debugLabel = 'taskCompleteAtom'

export const useTaskComplete = () => {
  const [taskComplete, setTaskComplete] = useAtom(taskCompleteAtom)

  return {
    taskComplete,
    setTaskComplete,
  }
}
